/**
 * Translation utilities using vue-i18n for use in non-component contexts (stores, utilities...)
 */

import { i18n } from '@/common/i18n'

/**
 * Mapping from common HTTP error messages (English) to translation keys
 */
const httpErrorMapping: Record<string, string> = {
  'forbidden': 'errors.forbidden',
  'unauthorized': 'errors.unauthorized',
  'bad request': 'errors.badRequest',
  'internal server error': 'errors.internalServerError',
  'not found': 'errors.notFound',
  'service unavailable': 'errors.serviceUnavailable',
  'gateway timeout': 'errors.gatewayTimeout',
  'request timeout': 'errors.requestTimeout',
}

/**
 * Get translation by key (for use outside Vue components)
 */
export function t(key: string, params?: Record<string, any>): string {
  return i18n.global.t(key, params ?? {})
}

/** Стандартные подписи кнопок диалогов Messages / Confirm. */
export function dialogOkLabel(): string {
  return t('dialogs.ok')
}

export function dialogCancelLabel(): string {
  return t('dialogs.cancel')
}

/**
 * Translate HTTP error message to localized message

 */
export function translateErrorMessage(message: string | undefined | null): string | null {
  if (!message) return null

  const lowerMessage = message.toLowerCase().trim()

  // Check exact match first
  if (httpErrorMapping[lowerMessage]) {
    return t(httpErrorMapping[lowerMessage])
  }

  // Check if message contains any of the English terms
  for (const [enTerm, key] of Object.entries(httpErrorMapping)) {
    if (lowerMessage.includes(enTerm)) {
      return t(key)
    }
  }

  return null
}

/**
 * Get error message for HTTP status code
 */
export function getErrorMessageForStatus(status: number): string {
  const statusMessages: Record<number, string> = {
    400: 'errors.badRequest',
    401: 'errors.unauthorized',
    403: 'errors.forbidden',
    404: 'errors.notFound',
    500: 'errors.internalServerError',
    503: 'errors.serviceUnavailable',
    504: 'errors.gatewayTimeout',
  }

  return statusMessages[status] ? t(statusMessages[status]) : t('errors.internalServerError')
}

